import { createMuiTheme } from '@material-ui/core/styles';

export const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#f50057',
      contrastText: '#ffffff'
    },
    secondary: {
      main: '#0B6623',
      contrastText: '#ffffff'
    }
  }
});
